import { IconButton, Typography, styled, Box } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';
import theme from 'constants/theme';

const CloseButton = styled(IconButton)(({ theme }) => ({
  float: 'right',
  padding: `0px ${theme.spacing(5)}px`,
  backgroundColor: theme.white,
}));

const ModalTitle = ({ children, onClose, subtitle, titleId, subtitleId }) => {
  const { t } = useTranslation();
  return (
    <Box margin={0} padding={theme.spacing(4)}>
      <Box display="flex" justifyContent="space-between">
        <Typography sx={{ fontWeight: 'bold' }} variant="h2" component="h2" id={titleId}>
          {children}
        </Typography>
        {onClose && (
          <CloseButton
            aria-label={t('components.close')}
            data-testid="close"
            onClick={onClose}
            iconName="times"
            borderless
          />
        )}
      </Box>
      <Typography sx={{ fontWeight: 'normal', mt: 1 }} component="h3" id={subtitleId}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default ModalTitle;
